module.exports = function() {
    ICF.Utils.EqualHeights.RegisterSetEqualHeights('.sidebar-block', 0);
};